import { put, call } from "redux-saga/effects";

import { SAVE_PASSWORDRESET_COMPLETED,SAVE_PASSWORDRESET_FAILED,GET_ACTCODEPASSWORD_COMPLETED,GET_ACTCODEPASSWORD_FAILED} from "../actions/Passwordreset";

import { PasswordresetApi } from "../../utils/api/PasswordresetApi";



export function* savenewPassword(request: any) {
 
    
    try {
       
         const result=yield call(PasswordresetApi.savepasswordreset, request.input);
        
        yield put({
            
            type: SAVE_PASSWORDRESET_COMPLETED,     
            payload: result.data,
            input: request.input
        });
    } catch (e) {
        yield put({ type: SAVE_PASSWORDRESET_FAILED, payload: e.message });
    }
    
}
export function* getactcodepassword(request: any) {
    try {
      const result = yield call(PasswordresetApi.getpasswordbyactcode,request.input);
    
    //  var status = result.data;
      
          yield put({
              type: GET_ACTCODEPASSWORD_COMPLETED,
              payload: result.data,
              input: request.input
          });        
          
      } catch (e) {        
          yield put({ type: GET_ACTCODEPASSWORD_FAILED, payload: e.message });
      }
  }